import React from "react";
import { Row, Column } from "react-foundation";

import Logo from "components/Logo";
import { connect } from "react-redux";
import { setCustomerAsDGN } from "./../../actions";
import Loading from "../../components/Loading";

const RedirectToDGN = ({ history, setCustomerAsDGN }) => {
    var timeoutLength = 10000;

    setTimeout(() => {
        setCustomerAsDGN(() => {
            setTimeout(() => {
                history.push("/GetQuote/Postcode");
            }, timeoutLength / 2);
        });
    }, timeoutLength / 2);
    return (
        <div style={{ position: "relative" }}>
            <Logo topLeft={true} />
            <Row className="top-padding-page">
                <Column small={10} medium={8} large={6} centerOnSmall>
                    <h3>
                        We don’t sell directly to the public, but we’re redirecting you to the
                        Double Glazing Network where you can get a price
                    </h3>
                    <div>
                        <Loading text={false} />
                    </div>
                </Column>
            </Row>
        </div>
    );
};

export default connect(null, { setCustomerAsDGN })(RedirectToDGN);



// WEBPACK FOOTER //
// ./src/containers/QuoteForm/RedirectToDGN.js